import { EditablePath, useEditable } from "../editable/EditableContext";

export interface ToneOption {
  value: string;
  label: string;
}

/** The semaphore most elements paint with. */
export const SEMAPHORE_OPTIONS: ToneOption[] = [
  { value: "green", label: "Verde" },
  { value: "amber", label: "Ámbar" },
  { value: "red", label: "Rojo" },
  { value: "neutral", label: "Neutro" },
];

const selectStyle = {
  fontSize: 10,
  lineHeight: 1.4,
  padding: "0 2px",
  marginLeft: 4,
  border: "1px solid rgba(99,102,241,0.35)",
  borderRadius: 4,
  background: "#fff",
  color: "#4338ca",
  cursor: "pointer",
  verticalAlign: "middle",
  textTransform: "none",
  letterSpacing: "normal",
  fontWeight: 400,
} as const;

/**
 * Picker for a field with a closed set of values.
 *
 * @param path Where the picked value is written.
 * @param value The current value; the renderer's own default when the payload has none.
 * @param options What can be picked, in display order.
 * @param toValue Maps the picked option to what is written at `path`, for a choice
 *   that changes more than one field (a callout switching between kind and tone).
 */
export const ToneSelect = ({ path, value, options, toValue, title = "Color" }: {
  path?: EditablePath;
  value: string;
  options: ToneOption[];
  toValue?: (picked: string) => unknown;
  title?: string;
}) => {
  const { editable, onChange } = useEditable();
  if (!path || !editable) return null;
  return (
    <select
      title={title}
      value={value}
      style={selectStyle}
      // The picker usually sits inside a clickable leaf or a pill; the click
      // that opens it must not also open the text field around it.
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => onChange(path, toValue ? toValue(e.target.value) : e.target.value)}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>{option.label}</option>
      ))}
    </select>
  );
};
